import React from 'react'
import { Button } from './index.styled'

const AnimatedCrossButton = ({ className, ...props }) => {
  return (
    <Button className={className} {...props}>
      <span />
    </Button>
  )
}

export default AnimatedCrossButton
